(function () {
    "use strict";
    angular.module("app.core").filter("priceformat", replace);

    function replace() {
        return replaceFilter;

        function replaceFilter(input, format) {
            input = input || 0;
            format = format || "<ins>{0}<span>,{1}</span> ₺</ins>";
            var inputString = format.toString();
            var priceInt = formatNumber((input.toFixed(2) + "").split(".")[0]);
            var priceDecimal = (input.toFixed(2) + "").split(".")[1] || "00";
            inputString = inputString.replace("{0}", priceInt);
            inputString = inputString.replace("{1}", priceDecimal);
            return inputString;
        }
    }

    function formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }
})();
